<template>
  <div class="container">
    <div class="content-container">
      <div v-if="articleContent.contentTitle" class="article-content-title">{{ articleContent.contentTitle.replace(/&nbsp;/g, ' ') }}</div>

      <article-content
        :showVocab="true"
        class="article-content-snapshot"
        :content="articleContent.fullContent"
      ></article-content>
    </div>
    <reading-footer
      :active="activeFooter"
      text="去答题"
      :onItemClick="this.onFooterClick"
      :onButtonClick="this.startAnswer"
    />
    <level-selector-modal
      v-if="activeFooter == READING_FOOTER_TYPE.LEVEL"
      v-show="activeFooter == READING_FOOTER_TYPE.LEVEL"
      :onLevelChange="this.onLevelChange"
      :onClose="this.onModalClose"
    />
    <background-video-modal
      v-if="activeFooter == READING_FOOTER_TYPE.BACKGROUND_VIDEO"
      v-show="activeFooter == READING_FOOTER_TYPE.BACKGROUND_VIDEO"
      :onClose="this.onModalClose"
    />
    <new-word-modal
      v-if="activeFooter == READING_FOOTER_TYPE.NEW_WORD"
      v-show="activeFooter == READING_FOOTER_TYPE.NEW_WORD"
      :words="words"
      :onClose="this.onModalClose"
    />
  </div>
</template>
<script>
import ReadingFooter from "../../components/footer/ReadingFooter";
import ArticleContent from "../../components/content/ArticleContent";
import LevelSelectorModal from "./component/LevelSelectorModal";
import BackgroundVideoModal from "./component/BackgroundVideoModal";
import NewWordModal from "./component/NewWordModal";
import { READING_FOOTER_TYPE } from "../../contants/article";
import { mapState } from "vuex";
import * as ActionTypes from "@/store/action-types";

export default {
  name: "ReadingPage",
  data() {
    return {
      READING_FOOTER_TYPE: READING_FOOTER_TYPE,
      FOOTER_ITEMS: [
        {
          label: "当前难度",
          type: READING_FOOTER_TYPE.LEVEL,
        },
        {
          label: "文章导读",
          type: READING_FOOTER_TYPE.BACKGROUND_VIDEO,
        },
        {
          label: "生词本",
          type: READING_FOOTER_TYPE.NEW_WORD,
        },
      ],
      activeFooter: -1,
      articleLevel: { name: "150L", desc: "适合：小升初、pet预备" },
    };
  },

  components: {
    ReadingFooter,
    ArticleContent,
    LevelSelectorModal,
    BackgroundVideoModal,
    NewWordModal,
  },
  computed: {
    ...mapState({
      words: (state) => state.article.words,
      articleDetail: (state) => state.article.articleDetail,
      contentId: (state) => state.article.contentId,
      levels: (state) => state.article.levels,
      articleContent: (state) => state.article.articleContent,
      wordBook: (state) => state.article.wordBook,
    }),
    selectLevel() {
      let level = _.filter(
        this.$store.state.article.levels,
        (item) => item.contentId == this.contentId
      );
      return level[0];
    },
  },
  mounted() {
    console.log("==========>");
  },
  activated() {
    console.log("===>activeFooter", this.activeFooter);
    this.$store.dispatch(ActionTypes.GET_ARTICLE_CONTENT);
  },
  methods: {
    onBack() {
      location.href = "/home";
    },
    onFooterClick(footerType) {
      console.log("onFooterClick = ", this.wordBook);
      this.activeFooter = footerType;
    },
    onLevelChange(levelItem) {
      console.log("levelItem");
      // this.articleLevel = levelItem;
      this.$store.dispatch(
        ActionTypes.SELECT_ARTICLE_CONTENT,
        levelItem.contentId
      );
      this.activeFooter = 0;
    },
    startAnswer() {
      this.$router.push({ path: "/answerPage" });
    },
    onModalClose() {
      this.activeFooter = 0;
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container {
  min-height: 100vh;
  padding-bottom: 50px;
  background: #F7F8FB;
}

.guide-container {
  padding: 15px;
  background: #ffffff;
}

.article-content-snapshot {
  padding-bottom: 10px;
  font-size: 14px;
}

.article-content-title {
  font-size: 18px;
  color: #333333;
  font-family: serif,SimSun,STSong;
  font-weight : bold
  margin: 5px 0;
}

.content-container {
  flex: 1;
  padding: 15px;
  background: #ffffff;
  overflow: scroll;
}
</style>


// WEBPACK FOOTER //
// app/pages/article/ReadingPage.vue